import { Trash } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const DeleteIcon = DeckardIconWrapper({ Icon: Trash });
